<template>
  <div class="grid px-3 py-4">
    <div id="edutable">
      <p class="text-xl text-blue-400 font-medium">
        Details of Educational Record from Matriculation onwards :
      </p>
    </div>
    <div class="overflow-y-auto">
      <table class="table w-full">
        <thead>
          <tr>
            <th></th>
            <th>From</th>
            <th>To</th>
            <th>Institution</th>
            <th>Degree / Diploma</th>
            <th>Subject Specialisation</th>
            <th>Class Obtained</th>
            <th>Grade</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(entry, i) in education" :key="i">
            <th scope="row">{{ ++i }}</th>
            <td>{{ entry.From }}</td>
            <td>{{ entry.To }}</td>
            <td>{{ entry.Institution }}</td>
            <td>{{ entry.Degree_Diplomo }}</td>
            <td>{{ entry.Major }}</td>
            <td>{{ entry.percentage }}</td>
            <td>{{ entry.Grade }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "Eduinfo",
  computed: {
    education() {
      return this.$store.state.Candidate.application.education;
    },
  },
};
</script>
